import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const getInvoicePdf = (axios: IAxiosInstance) => {
  return async (invoiceID: string, accessToken?: string): Promise<string> => {
    const params = {
      ...(accessToken ? { accessToken } : {}),
      returnUrl: "1",
    };
    const response = await axios.noRetry.get<IApiResponse<string>>(
      `/api/invoices/${invoiceID}/pdf`,
      { params }
    );
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
